import {PageHeader, SidebarMain, Skeleton} from '@sollapay/ui/components';
import {AccountNavSkeleton, AppSidebar as GenericAppSidebar} from '@sollapay/web-core';
import {useTranslation} from 'react-i18next';

import {AppLogo, AppLogomark} from './AppLogo';
import {PageContent, PageLayout} from './PageLayout';
import {APP_SIDEBAR_STORAGE_KEY} from '../config/sidebar.config';

import type {FC} from 'react';

/** The app's outline, shown while Auth0 confirms a likely sign-in. */
export const AppShellSkeleton: FC = () => {
  const {t} = useTranslation('common');

  return (
    <GenericAppSidebar
      logo={<AppLogo />}
      collapsedLogo={<AppLogomark />}
      storageKey={APP_SIDEBAR_STORAGE_KEY}
      footer={<AccountNavSkeleton />}
      isLoading
    >
      <SidebarMain className="overflow-hidden">
        <span role="status" className="sr-only">
          {t('loading')}
        </span>
        <PageLayout aria-hidden data-slot="app-shell-skeleton">
          <PageHeader
            title=""
            titleNode={<Skeleton className="h-8 w-56" />}
            description={<Skeleton className="h-4 w-80" />}
          />
          <PageContent>
            <Skeleton className="h-80 w-full rounded-xl" />
          </PageContent>
        </PageLayout>
      </SidebarMain>
    </GenericAppSidebar>
  );
};
